import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["direction", "container", "onEnter", "onEntering", "onExited", "onExit", "in", "duration"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useCallback, useEffect, useRef } from "react";
import Animated from "../Animated";
import { setTranslateValue } from "./utils/setTranslateValue";
import { debounce } from "@peersyst/react-utils";
import { getDuration } from "../helpers";
import { getExitedPosition } from "./utils/getExitedPosition";
import { useForkRef } from "@peersyst/react-hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var Slide = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var direction = _ref.direction,
      container = _ref.container,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onExited = _ref.onExited,
      onExit = _ref.onExit,
      inProp = _ref["in"],
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 500 : _ref$duration,
      animatedProps = _objectWithoutProperties(_ref, _excluded);

  var handleEnter = function handleEnter(node, isAppearing) {
    node.style.transitionDuration = "0ms";
    setTranslateValue(direction, node, container);
    onEnter == null ? void 0 : onEnter(node, isAppearing);
  };

  var handleEntering = function handleEntering(node, isAppearing) {
    node.style.transitionDuration = getDuration(duration, "entering") + "ms";
    node.style.transform = "none";
    onEntering == null ? void 0 : onEntering(node, isAppearing);
  };

  var handleExit = function handleExit(node) {
    setTranslateValue(direction, node, container);
    onExit == null ? void 0 : onExit(node);
  };

  var handleExited = function handleExited(node) {
    onExited == null ? void 0 : onExited(node);
  };

  var childrenRef = useRef(null);
  var handleRef = useForkRef(childrenRef, ref);
  var updatePosition = useCallback(function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, container);
    }
  }, [direction, container]);
  useEffect(function () {
    if (!inProp) {
      updatePosition();
    }
  }, [inProp, updatePosition]);
  useEffect(function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === "down" || direction === "right") {
      return undefined;
    }

    var handleResize = debounce(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, container);
      }
    });
    window.addEventListener("resize", handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [direction, inProp, container]);
  return /*#__PURE__*/_jsx(Animated, _objectSpread(_objectSpread({
    ref: handleRef,
    animation: {
      exited: {
        transform: getExitedPosition(direction)
      }
    },
    animatedProperties: "transform",
    "in": inProp,
    duration: duration,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited
  }, animatedProps), {}, {
    unmountOnExit: true,
    mountOnEnter: true
  }));
});
Slide.displayName = "Slide";
export default Slide;